// import React from 'react';
import '../../../Library.css'; /* Global App */

// import Mobile from './media/mobile.png';
// import Logo from './svg/LogoV0';

function MobileView() {
  window.location.href = `https://pages.beatport-lp.com/beatsource-dj-mobile`;
  return null;
  // return (
  //   	<div className={'bpc bp-mobile flexColumn space-around'} style={{background: '#fff', color: 'black', gap: 36}} >
  //       <Logo colorBrand={'black'} width={'60%'} height={'auto'} style={{ marginTop: '12%', marginBottom: 12 }} />
  //   		<h1 style={{ display: 'none' }}>Beatsource DJ Web App is your one-stop web browser solution for digging, discovery and playlist creation. Immerse yourself in the curated selections from our team of genre experts.</h1>
  //   		<img alt={'mobile_djapp'} width="100%" style={{ width: '100%' }} src={Mobile}></img>
  //       <div className={'flexColumn'} style={{margin: '0px 40px', gap: 80}}>
  //     		<span className={'bold'} style={{ fontSize: '3em', margin: '0px 30px', lineHeight: 'initial' }}>
  //     			We’re bringing the party to the browser.
  //     		</span>
  //         <div className={'flexColumn'} style={{fontSize: '1.2em', margin: '0px 20px', gap: 36}}>
  //           <span style={{ fontSize: '1.5em', lineHeight: 'initial' }}>
  //       			Quickly find and discover music.
  //       		</span>
  //       		<span style={{ fontSize: '1.5em', lineHeight: 'initial' }}>
  //       			Instantly test and mix tracks.
  //       		</span>
  //       		<span style={{ fontSize: '1.5em', lineHeight: 'initial' }}>
  //       			Easily build performance playlists.
  //       		</span>
  //         </div>
  //     		<span className={'brand-primary bold'} style={{ fontSize: '1.5em', lineHeight: '2em', margin: '0px 20px' }}>
  //     			Beatsource DJ is a desktop web app only and is designed to work in Google Chrome, and is available to Beatsource LINK users.
  //     		</span>
  //         <span style={{ fontSize: '1.5em', lineHeight: '2em', margin: '0px 20px 50px 20px' }}>
  //           With the future of DJ streaming and music discovery only a few clicks away, there is no better time than NOW to join the Beatsource LINK community.
  //         </span>
  //       </div>
  //   	</div>
  // )
}

export default MobileView;
